<template>
  <div
      class="kyra-fixed-bg bg-container"
      :style="{background: colorArrayToLinearGradient(bgColors, 160)}"
  >
    <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
      <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
      </defs>
      <g :class="['parallax', {animated: animateBGIfAvailable}]">
        <use xlink:href="#gentle-wave" :x="getX(0)" y="0" :fill="isDark ? 'rgba(0,0,0,0.9)' : 'rgba(255,255,255,0.9)'" />
        <use xlink:href="#gentle-wave" :x="getX(30)" y="3" :fill="isDark ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.7)'" />
        <use xlink:href="#gentle-wave" :x="getX(70)" y="5" :fill="isDark ? 'rgba(0,0,0,0.4)' : 'rgba(255,255,255,0.4)'" />
        <use xlink:href="#gentle-wave" :x="getX(100)" y="7" :fill="isDark ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.2)'" />
      </g>
    </svg>
  </div>
</template>

<script>

import { colorArrayToLinearGradient } from "@/utils/UI";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: 'WavesBackground',
  mixins: [ UIMixin ],
  props: {},
  data() {
    return { }
  },
  mounted() {
  },

  beforeDestroy() {
  },
  methods: {
    colorArrayToLinearGradient,
    getX(offset = 20){
      const vm = this
      return vm.animateBGIfAvailable ? 48 : 48 + offset
    }
  },
}
</script>
<style scoped lang="scss">
  .bg-container {
    overflow: hidden;
  }
  .waves {
    opacity: .8;
    position:absolute;
    bottom: 0;
    width: 100%;
    height:45vh;
    margin-bottom:-7px; /*Fix for safari gap*/
    min-height:100px;
    max-height:250px;
  }

  /* Animation */
  .parallax.animated > use {
    animation: move-forever 25s cubic-bezier(.55,.5,.45,.5) infinite;
  }
  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }
  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }
  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }
  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }
  @keyframes move-forever {
    0% {
      transform: translate3d(-90px,0,0);
    }
    100% {
      transform: translate3d(85px,0,0);
    }
  }
  /*Shrinking for mobile*/
  @media (max-width: 768px) {
    .waves {
      height: 40px;
      min-height: 40px;
    }
  }
</style>
